import { useEffect } from 'react';
import { Navigation } from '../navigation';
import Footer from '../footer';
import './quantome.css';
import QuantomeHeader   from './QuantomeHeader';
import QuantomeAbout    from './QuantomeAbout';
import QuantomeFeatures from './QuantomeFeatures';
import QuantomeServices from './QuantomeServices';
import QuantomeScan     from './QuantomeScan';
import QuantomeContact  from './QuantomeContact';

const QuantomePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Navigation />
      <QuantomeHeader />
      <QuantomeScan />
      <QuantomeAbout />
      <QuantomeFeatures />
      <QuantomeServices />
      <QuantomeContact />
      <Footer />
    </div>
  );
};

export default QuantomePage;
